import React from 'react';
import { Modal } from 'react-bootstrap';
import { currencyFormat } from 'utilities/common';

const WeightRanges = ({ data }) => {
  const [isShow, setIsShow] = React.useState(false);

  const $handleClose = () => {
    setIsShow(false);
  };

  if (!data?.weight_ranges) {
    return null;
  }

  return (
    <>
      <div
        className="btn btn-primary py-1 fs-7"
        onClick={() => setIsShow(true)}
      >
        <div>Daftar harga</div>
      </div>
      <Modal
        show={isShow}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
        scrollable
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose}></div>
          <div>
            <div className="text-center fs-6">
              Daftar Kisaran Harga <br />
              <b>
                {data?.service_type?.service?.name} - {data?.service_type?.name}
              </b>
            </div>
            <div className="mt-3">
              <div className="table-responsive m-0">
                <table
                  width="100%"
                  className="table table-hover table-vcenter card-table datatable border"
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td
                        style={{
                          whiteSpace: 'initial',
                          textAlign: 'center',
                        }}
                      >
                        No
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '300px',
                        }}
                      >
                        Berat Minimal
                      </td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '300px',
                        }}
                      >
                        Harga Jual
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.weight_ranges?.map((d, i) => (
                      <tr key={i}>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            textAlign: 'center',
                          }}
                        >
                          {i + 1}
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '300px',
                          }}
                        >
                          {d?.weight_less} Kg
                        </td>
                        <td
                          style={{
                            whiteSpace: 'initial',
                            width: '300px',
                          }}
                        >
                          {currencyFormat(d?.nlv)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WeightRanges;
